require('./cancelBizumStep1.scss');

// @ vendors
const React = require('react');

// @ commons
const { FormattedText } = require('core/i18n').i18n;

// @ components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

class CancelBizumStep1 extends React.Component {
    render() {
        return (
            <div className="cancel-bizum-step1">
                <h4 className="cancel-bizum-step1__title wizard-step--vertical__title">
                    <FormattedText value="cardGenericConfirmationStep-title" />
                </h4>
                <div className="cancel-bizum-step1__main-content">
                    <BlockInfo extraClass="cancel-bizum-step1__block-info">
                        <p className="cancel-bizum-step1__unsuscribe-message">
                            <FormattedText value="cancelBizumStep1-unsuscribeMessage"/>
                        </p>
                        <br/>
                        <p className="cancel-bizum-step1__pending-operations-message">
                            <FormattedText value="cancelBizumStep1-pendingOperationsMessage"/>
                        </p>
                        <p className="cancel-bizum-step1__confirmation-message no-print-out">
                            <FormattedText value="cancelBizumStep1-confirmationMessage"/>
                        </p>
                    </BlockInfo>
                </div>
            </div>
        );
    }
}

module.exports = CancelBizumStep1;
